import { render, staticRenderFns } from "./security-group-dialog.vue?vue&type=template&id=0f9881d4"
import script from "./security-group-dialog.vue?vue&type=script&lang=ts"
export * from "./security-group-dialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports